import React, { createContext } from 'react'
import useAuth from '../hooks/useAuth'

export const AuthContext = createContext({
  user: null,
  resourceAllowed: [],
  isLoading: true,
  bootstrap: {},
  setBootstrap: () => {},
})

const AuthContextProvider = props => {
  const { user, resourceAllowed, isLoading, bootstrap, setBootstrap } = useAuth()

  return (
    <AuthContext.Provider
      value={{
        user,
        resourceAllowed,
        isLoading,
        bootstrap,
        setBootstrap,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContextProvider
